// AP-082 · Seletor de idioma do Portal do Cliente.
// - Botão redondo com bandeira do idioma atual + chevron pequeno.
// - Dropdown com as 5 opções (bandeira + nome nativo).
// - Troca instantânea (usePortalI18n().setLang).
import React from "react";
import { Check } from "lucide-react";
import {
  DropdownMenu, DropdownMenuTrigger, DropdownMenuContent, DropdownMenuItem, DropdownMenuLabel, DropdownMenuSeparator,
} from "../../components/ui/dropdown-menu";
import { PORTAL_LANGS, usePortalI18n } from "./PortalI18nContext";

export default function PortalLanguageSwitcher() {
  const { lang, setLang, t } = usePortalI18n();
  const current = PORTAL_LANGS.find((l) => l.code === lang) || PORTAL_LANGS[0];
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button
          data-testid="portal-language-switcher"
          aria-label={t("lang.switch")}
          className="inline-flex h-10 items-center gap-1.5 rounded-full pl-2.5 pr-2 border border-border/60 bg-white/60 hover:bg-white hover:border-primary/40 transition-all duration-150 active:scale-95"
        >
          <span className="text-base leading-none" aria-hidden="true">{current.flag}</span>
          <span className="text-[11px] font-semibold uppercase tracking-widest text-muted-foreground">{current.code}</span>
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent
        align="end" sideOffset={8}
        className="w-52 animate-in fade-in-0 zoom-in-95 slide-in-from-top-2 duration-150"
        data-testid="portal-language-menu"
      >
        <DropdownMenuLabel className="text-[11px] uppercase tracking-widest text-muted-foreground">
          {t("lang.switch")}
        </DropdownMenuLabel>
        <DropdownMenuSeparator />
        {PORTAL_LANGS.map((l) => (
          <DropdownMenuItem
            key={l.code}
            data-testid={`portal-lang-option-${l.code}`}
            onSelect={() => setLang(l.code)}
            className="flex items-center gap-2 cursor-pointer"
          >
            <span aria-hidden="true" className="text-base leading-none">{l.flag}</span>
            <span className="flex-1 text-sm">{l.label}</span>
            {lang === l.code && <Check className="h-3.5 w-3.5 text-primary" />}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
